import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const ProtectedRoutes = ({
  isAuthenticated,
  isLoading,
  role,
  requiredRole,
}) => {
  // console.log(role, requiredRole, isAuthenticated);
  if (isLoading) {
    return null; // or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  if (role !== requiredRole) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
